import { render, staticRenderFns } from "./overflowGoods.vue?vue&type=template&id=657c2a9b&scoped=true&"
import script from "./overflowGoods.vue?vue&type=script&lang=js&"
export * from "./overflowGoods.vue?vue&type=script&lang=js&"
import style0 from "./overflowGoods.vue?vue&type=style&index=0&id=657c2a9b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657c2a9b",
  null
  
)

export default component.exports